import {User} from 'projects/core/src/lib/login/data/user';
import {AbstractModel, DateConverter, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ShortProject} from '../../project-misc/data/project/short-project';
import {Customer} from '../../customer/data/customer';
import {ProjectStatus} from '../../project-misc/data/project/statuses/project-status';
import {PricingArea} from './pricing-area';
import {B} from '@angular/cdk/keycodes';


@JsonObject('model.ProjectPricingCounters')
export class ProjectPricingCounters extends AbstractModel {
  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(Number, 'cabinetryTotal')
  cabinetryTotal: number;

  @JsonProperty(Number, 'grandTotal')
  grandTotal: number;

  @JsonProperty(Number, 'subtotal')
  subtotal: number;

  @JsonProperty(Number, 'subtotalDelivery')
  subtotalDelivery: number;

  @JsonProperty(Number, 'subtotalInstall')
  subtotalInstall: number;
}

@JsonObject('model.ProjectPricing')
export class ProjectPricing extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(Boolean, 'active')
  active?: boolean

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty([PricingArea], 'areas')
  areas?: PricingArea[]

  @JsonProperty(User, 'createdBy')
  createdBy?: User

  @JsonProperty(Customer, 'customer')
  customer?: Customer

  @JsonProperty(DateConverter, 'createdTime')
  createdTime?: Date

  @JsonProperty(Number, 'grandTotal')
  grandTotal?: number

  @JsonProperty(ShortProject, 'project')
  project?: ShortProject

  @JsonProperty(ProjectStatus, 'status')
  status?: ProjectStatus

  @JsonProperty(Number, 'discount1')
  discount1?: number

  @JsonProperty(Number, 'discount2')
  discount2?: number

  @JsonProperty(String, 'discount2Title')
  discount2Title?: string

  @JsonProperty(Number, 'subtotal')
  subtotal?: number

  @JsonProperty(Number, 'subtotalDelivery')
  subtotalDelivery?: number

  @JsonProperty(Number, 'subtotalInstall')
  subtotalInstall?: number

  @JsonProperty(Number, 'cabinetryTotal')
  cabinetryTotal?: number
}

